export function customEvent() {
  return next => action => {
    next(action);
    window.dispatchEvent(new CustomEvent('REDUX_' + action.type, { detail: action }))
  }
}
